import { Outlet, useParams } from 'react-router-dom'

import { isEmpty } from 'lodash'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import CollectionsBootstrap from 'modules/goals/lib/CollectionsBootstrap'

const RootPage = () => {
  const params = useParams()

  useEffect(() => {
    // Ensure we only track the first time the user visits the goals module
    if (isEmpty(params)) track(trackingEvents.goals.goToGoal)
  }, [])

  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
